












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ListItem extends Vue {
  @Prop({ type: Boolean })
  readonly active!: boolean;

  @Prop({ type: Boolean })
  readonly disabled!: boolean;

  get itemDisabled() {
    return this.active || this.disabled;
  }

  get classes() {
    const { root, active } = this.$style;

    return {
      [root]: true,
      [active]: this.active,
    };
  }
}
